var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.obj !== null)?_vm._t("default",null,{"obj":_vm.obj}):_vm._e(),(_vm.message !== null)?_c('p',[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]):_vm._e(),(_vm.isLoading)?_c('loading-indicator'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }